import Vue from 'vue'
import Router from 'vue-router'
// import store from '../store'
// import { mapActions } from 'vuex'

Vue.use(Router)
export const router = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/home/index'),
    meta: {
      title: '首页',
      keepAlive: false
    }
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/product'),
    meta: {
      title: '精品案例',
      keepAlive: false
    }
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/aboutUs'),
    meta: {
      title: '关于我们',
      keepAlive: false
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news'),
    meta: {
      title: '新闻资讯',
      keepAlive: false
    }
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('@/views/contactUs'),
    meta: {
      title: '联系我们',
      keepAlive: false
    }
  },
  {
    path: '/productDetails',
    name: 'productDetails',
    component: () => import('@/views/productDetails'),
    meta: {
      title: '产品详情',
      keepAlive: false
    }
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('@/views/newsDetails'),
    meta: {
      title: '新闻详情',
      keepAlive: false
    }
  },
  {
    path: '/blankPage',
    name: 'blankPage',
    component: () => import('@/views/blankPage'),
    meta: {
      title: '空白页',
      keepAlive: false
    }
  }
]

const getRoute = new Router({
  //mode: 'history', // 如果你是 history模式 需要配置vue.config.js publicPath
  mode: 'hash', // 如果你是 hash 需要配置vue.config.js publicPath
  // base: '/app/',
  scrollBehavior: () => ({y: 0}),
  routes: router
})
const defaultTitle = '企业网站'
getRoute.beforeEach((to, form, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle
  // store.dispatch('app/setLoading', true)
  // setTimeout(() => {
  //   store.dispatch('app/setLoading', false)
  // }, 1000)
  next()
})
export default getRoute
